export const UI_BASE_PATH: string =
  document.querySelector('base')?.getAttribute('href') ?? ''

export default UI_BASE_PATH
